<!-- Datepicker for gtDate, ltDate -->
@if (selectedOperator == 'gt' || selectedOperator == 'lt') {
  <mat-form-field class="entity-selector3" appearance="fill">
    <mat-label>Select Date</mat-label>
    <input [(ngModel)]="selectedDate" (dateChange)="dateModified()" matInput [matDatepicker]="activityDatePicker"
      placeholder="Select date">
      <mat-datepicker-toggle matSuffix [for]="activityDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #activityDatePicker></mat-datepicker>
    </mat-form-field>
  }

  <!-- Date Range Picker for inRange -->
  @if (selectedOperator == 'range') {
    <mat-form-field class="entity-selector3" appearance="fill">
      <mat-label>Select Date Range</mat-label>
      <mat-date-range-input [max]="maxDate" [rangePicker]="activityRangePicker">
        <input [(ngModel)]="startDate" (dateChange)="rangeDateModified()" matStartDate placeholder="Start date">
        <input [(ngModel)]="endDate" (dateChange)="rangeDateModified()" matEndDate placeholder="End date">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="activityRangePicker">
      </mat-datepicker-toggle>
      <mat-date-range-picker #activityRangePicker></mat-date-range-picker>
    </mat-form-field>
  }


  <!-- value and period - Day/Hour/Minute -->
  @if (selectedOperator == 'inPeriod##last' || selectedOperator == 'inPeriod##next' || selectedOperator == 'notInPeriod##last' || selectedOperator == 'notInPeriod##next') {
    <div class="d-flex flex-column w-100"
      >
      <mat-form-field appearance="fill">
        <mat-label>Select Unit:</mat-label>
        <mat-select [(ngModel)]="selectedUnit" (ngModelChange)="onUnitChange($event)">
          <mat-option value="DAY">Day</mat-option>
          <mat-option value="HOUR">Hour</mat-option>
          <mat-option value="MINUTE">Minute</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Enter Number:</mat-label>
        <input matInput type="number" [(ngModel)]="selectedNumber" (ngModelChange)="onNumberChange($event)" />
      </mat-form-field>
    </div>
  }

  <!-- property and value and period - Day/Hour/Minute -->
  @if (selectedOperator == 'gtp' || selectedOperator == 'ltp') {
    <div class="d-flex flex-column w-100">
      <mat-form-field appearance="fill">
        <mat-label>Select Other Date/Time property to compare with:</mat-label>
        <mat-select [(ngModel)]="selectedProperty" (ngModelChange)="onPropertyChange($event)">
          <mat-option value="prop1">Prop1</mat-option>
          <mat-option value="prop2">Prop2</mat-option>
          <mat-option value="prop3">Prop3</mat-option>
        </mat-select>
      </mat-form-field>
      <p>Optionally you can set the margin of difference between two properties:</p>
      <mat-form-field appearance="fill">
        <mat-label>Select Unit:</mat-label>
        <mat-select [(ngModel)]="selectedUnit" (ngModelChange)="onUnitChange($event)">
          <mat-option value="DAY">Day</mat-option>
          <mat-option value="HOUR">Hour</mat-option>
          <mat-option value="MINUTE">Minute</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Enter Number:</mat-label>
        <input matInput type="number" [(ngModel)]="selectedNumber" (ngModelChange)="onNumberChange($event)" />
      </mat-form-field>
    </div>
  }


  <!-- value - number between 0 and 24 -->
  @if (selectedOperator == 'gtHourOfDay' || selectedOperator == 'ltHourOfDay') {
    <div class="d-flex flex-column w-100">
      <mat-form-field appearance="fill">
        <mat-label>Enter hour between 1 and 24</mat-label>
        <input matInput type="number" min="1" max="24" [(ngModel)]="selectedHourOfDay"
          (ngModelChange)="onHourOfDayChange($event)">
        </mat-form-field>
      </div>
    }



    <!-- day of week -->
    @if (selectedOperator == 'dayOfTheWeek') {
      <ng-select class="entity-selector-query" #daySelect
        [items]="daysSelectionOptions" [selectOnTab]="true" [(ngModel)]="selectedDays" [multiple]="true"
        bindLabel="viewValue" bindValue="value" placeholder="Select Day(s)">
      </ng-select>
    }